import clone from "@/util/clone.mjs";

/**
 * Creates a valtio subscription callback that provides both the
 * next and previous state. The previous state value is cloned and
 * safe to mutate. Every call to this function will result in a copy of
 * the watched state held in memory. State is cloned to protect against
 * unwanted side effects.
 *
 * @param callback - The callback that will receive the next
 * value, previous value, and standard arguments for the valtio subscription
 * callback. Example: (next, prev, ...args) => {}
 * @param initialValue - An optional initial value for the previous value
 */
export default function subscriptionStateDiff<T>(
  callback: (previous: T, state: T, ...args: unknown[]) => void,
  initialValue: T,
) {
  let previous = clone(initialValue);
  return (state: T, ...args: unknown[]) => {
    try {
      callback(state, previous, ...args);
    } finally {
      previous = state === null ? previous : clone(state);
    }
  };
}
